import { DropdownItem, Textbox } from "@mcleod/components";
import { DatePart, DateUtil } from "@mcleod/core";
import { PortalCustomerSettings } from "@mcleod/portal-customer";

const dateFormatValue = 'yyyy-MM-dd HH:mm';
const dateFormatDropDown = 'MM/dd';

export function setSelectedDay(textbox: Textbox, date: any) {
    if (date == null) return;
    const items = textbox.items as DropdownItem[];
    const parsedDate = DateUtil.parseDate(date);
    if (parsedDate != null) {
        const selectedDate = DateUtil.formatDate(parsedDate, dateFormatDropDown);
        const selectedDateCaption = `(${selectedDate})`;
        if (items != null) {
            items.forEach(item => {
                if (item.displayValue.includes(selectedDateCaption)) {
                    textbox.selectedItem = item;
                    return;
                }
            })
        }
    }
    // if the date is outside the maxDaysOut range, add a DropdownItem.
    if (textbox.selectedItem == null) {
        const item = new DropdownItem(date, DateUtil.formatDate(parsedDate, 'EEEE (' + dateFormatDropDown + ')'));
        items.push(item);
        textbox.selectedItem = item;
    }
}

export function getDatesBasedOnMaxDaysOut(): DropdownItem[] {
    const settings = PortalCustomerSettings.get();
    const includeSunday = settings.ltl_include_sunday;
    const includeSaturday = settings.ltl_include_saturday;
    const includeHolidays = settings.ltl_include_holiday;
    const maxDaysOut = settings.ltl_max_days_out ?? 6;

    const dateItems: DropdownItem[] = [];
    let todayStr = "";

    if (maxDaysOut && maxDaysOut >= 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        todayStr = DateUtil.formatDateTime(today, dateFormatValue);
        if (includeDay(today, includeSunday, includeSaturday, includeHolidays)) {
            const displayValue = "Today (" + DateUtil.formatDate(today, dateFormatDropDown) + ")";
            const item = new DropdownItem(todayStr, displayValue);
            dateItems.push(item);
        }
        for (let i = 1; i <= maxDaysOut; i++) {
            const nextDay = DateUtil.dateAdd(DatePart.DAY, today, i);
            if (!includeDay(nextDay, includeSunday, includeSaturday, includeHolidays)) {
                continue;
            }
            const nextDayStr = DateUtil.formatDateTime(nextDay, dateFormatValue);
            if (i === 1) {
                const displayValue = "Tomorrow (" + DateUtil.formatDate(nextDay, dateFormatDropDown) + ")";
                const item = new DropdownItem(nextDayStr, displayValue);
                dateItems.push(item);
            }
            else {
                const displayValue = DateUtil.formatDate(nextDay, "EEEE (" + dateFormatDropDown + ")");
                const item = new DropdownItem(nextDayStr, displayValue);
                dateItems.push(item);
            }
        }
    }
    return dateItems;
}


function includeDay(date: Date, includeSunday: boolean, includeSaturday: boolean, includeHolidays: boolean) {
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0 && !includeSunday) {
        return false;
    }
    else if (dayOfWeek === 6 && !includeSaturday) {
        return false;
    }
    else if (DateUtil.isHoliday(date) && !includeHolidays) {
        return false;
    }
    return true;
}

